export default __webpack_public_path__ + "static/media/img2pro9.a94cb69f.jpeg";